const Palette = {
  WHITE: 'var(--sg-bg-surface, #ffffff)',
  CREAM: 'var(--sg-bg-secondary, #f4f5f7)',
  GREY: 'var(--sg-text-tertiary, #7a869a)',
  SECONDARY_TEXT: 'var(--sg-text-secondary, #5d6b82)',
  BLACK: 'var(--sg-text-primary, #172b4d)',
  VIOLET: 'var(--sg-brand-violet, #8d4dc9)',
  SUCCESS: 'var(--sg-status-success, #4bb543)',
  STORY: 'var(--sg-brand-story, #63ba3c)',
  TABLE_BORDER: 'var(--sg-border-default, #e0e0e4)',
  TEXT_FONT: 'var(--sg-text-primary, #172b4d)',
  EPIC: 'var(--sg-brand-epic, #904ee2)',
  CHECKBOX_SELECT_BORDER: 'var(--sg-border-input, #e7e7e7)',
  PRIMARY: 'var(--sg-brand-primary, #8b5cf6)',
  ERROR: 'var(--sg-status-error, #c00909)',
  ERROR_LIGHT: 'var(--sg-status-error-light, #e9706d)',
  FOCUS_RING: 'var(--sg-border-focus, #4c9aff)',
  TEXT_FONT_SECONDARY: 'var(--sg-text-secondary, #5d6b82)',
  LIGHT_VOILET: 'var(--sg-brand-violet, #8d4dc9)',
  BRAND_ACTIVE: 'var(--sg-brand-active, #2b1691)',
  FORM_FIELD_BORDER: 'var(--sg-border-input, #e7e7e7)',
  FORM_FIELD_PLACEHOLDER: 'var(--sg-text-placeholder, #8992a5)',
  FORM_FIELD_BACKGROUND: 'var(--sg-bg-input, #ffffff)',
  DROPDOWN_BACKGROUND: 'var(--sg-bg-dropdown, #091e420f)',
  DROPDOWN_OPTION_DISABLE_LABEL: 'var(--sg-text-disabled, #a5adba)',
  LOADER_BACKGROUND: 'var(--sg-bg-overlay, #ffffffe6)',
  LIGHT_BLACK: 'var(--sg-text-secondary, #5d6b82)',
  ENHANCE_BUTTON_COLOR: 'var(--sg-bg-enhance-button, #e6e8ec)',
  ASSIGNED_STORY_HIGHLIGHT: 'var(--sg-bg-highlight, #8d4dc90f)'
};

export default Palette;
